import { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';

import {
  Typography,
  FormControl,
  TextField,
  Button,
} from '@mui/material';
import { 
  ThemeProvider, 
  createTheme, 
} from '@mui/material/styles';
import {
  // CheckCircle,
  // Cancel,
  VisibilityOff,
  Visibility,
} from '@mui/icons-material';

import { HttpStatusCode } from 'axios';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { withTranslation } from 'react-i18next';
import i18n from '../assets/locales';

import '../assets/css/signin.css'

// import IUser from '../models/user.model';

import Layout from '../layouts/layout.component';

import AuthService from '../services/auth.service';


type Props = {
};

type State = {
  redirect: string | null,
  username: string,
  password: string,
  showPassword: boolean,
  loading: boolean,
  messageType: string,
  messageTitle: string,
  message: string,
  messageLink: string,
  messageLinkURL: string
};

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 13,
          fontWeight: 'bold',
          color: 'rgba(224, 224, 224, 0.98)' ,
        },
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // Standard
          '& .MuiInput-root': {
            color: 'rgba(255, 255, 255, 0.8) !important',
            // fontFamily: 'Arial',
            fontWeight: 'bold',
            '&:before': {
              borderColor: 'rgba(128, 128, 128, 0.8)',
              borderWidth: '1px',
            },
            '&:after': {
              borderColor: 'rgba(0, 98, 65, 0.8)',
              borderWidth: '2px',
            },
            ':hover:not(.Mui-focused)': {
              '&:before': {
                borderColor: 'rgba(231, 231, 231, 0.8)',
                borderWidth: '1px',
              },
            },
          },
        }
      }
    },
  },
});


class Signin extends Component<Props, State> {   
  constructor(props: Props) {
    super(props);
    
    this.handleShowPassword = this.handleShowPassword.bind(this);
    this.handleSignup = this.handleSignup.bind(this);
    this.handleSignin = this.handleSignin.bind(this);

    this.state = {
      redirect: null,
      username: '',
      password: '',
      showPassword: false,
      messageType: '',
      messageTitle: '',
      message: '',
      messageLink: '',
      messageLinkURL: '',
      loading: false,
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({ redirect: '/profile' });
    };
  }

  componentWillUnmount() {
    window.location.reload();
  }

  validationSchema() {
    return Yup.object().shape({
      username: Yup.string()
        .required('This field is required!')
        .min(4, 'Username must be at least 4 characters'),
      password: Yup.string()
        .required('This field is required!')
        .min(8)
        .max(20),
    });
  }

  handleShowPassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  }

  handleSignup() {
    window.location.href = '/account/register';
  }

  handleSignin(values: { username: string; password: string; }) {
    const { username, password } = values;

    // console.log(values);

    this.setState({
      message: '',
      messageLink: '',
      messageLinkURL: '',
      loading: true,
    });

    AuthService.signin(
      username, 
      password
    ).then(
      async (res) => {
        console.log(`signin -> ${res.status} ${res.statusText}`);
        if (res.status === 202) {
          this.setState({
            loading: false,
            redirect: '/profile'
          });
        } else {
          console.log(`res: ${JSON.stringify(res, null, 2)}`);

          this.setState({
            loading: false,
          });
        }
      },
      (err) => {
        console.log(`Signin error: ${err.status} ${err.code}`);

        let messageTitle = '';
        let message =
          (err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          err.toString();
        let messageLink = '';
        let messageLinkURL = '';

        if (err.response && err.response.status === HttpStatusCode.BadRequest) {
          messageTitle = 'Sign in unsuccessful.';
          message = 'The username or password you entered is not valid. Please try again.';
          this.setState({
            loading: false,
            messageType: 'error',
            messageTitle: messageTitle,
            message: message,
          });
        } else if (err.response && err.response.status === HttpStatusCode.PreconditionFailed) {
          messageTitle = 'Sign in unsuccessful.';
          message = `Please check your email for verification link and verify your account before signing in.`;
          messageLink = `Resend Verification`;
          messageLinkURL = `/signin/resend-verification?username=${username}`;
          this.setState({
            loading: false,
            messageType: 'error',
            messageTitle: messageTitle,
            message: message,
            messageLink: messageLink,
            messageLinkURL: messageLinkURL,
          });
        } else if (err.response && err.response.status === HttpStatusCode.NotAcceptable) {
          messageTitle = 'Sign in unsuccessful.';
          message = 'Your account is locked. Please contact support.';
          this.setState({
            loading: false,
            messageType: 'error',
            messageTitle: messageTitle,
            message: message,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
      }
    );
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to = { this.state.redirect } />
    }

    const {
      loading,
      showPassword,
      messageTitle,
      message,
      messageLink,
      messageLinkURL
    } = this.state;

    const initialValues = {
      username: '',
      password: '',
    };

    return (
      <Layout>
        <div className='container col-md-12'>
          <div className='container mt-5 mb-5' />
          <div className='container-fluid text-center'>
            <Typography variant='h4'><b>Step into the game,</b></Typography>
          </div>
          <div className='container-fluid text-center'>
            <Typography variant='h4'><b>Stay in the reality.</b></Typography>
          </div>
          {/* <div className='container-fluid mt-3 mb-3'>
            <p className='fs-1 text-center'>
              <b className='text-success'>{i18n.t('signin:creditRegistration')}</b>
            </p>
          </div> */}
          {/* <div className='container-fluid mt-3'>
            <p className='fs-5 text-center text-description'>
              { i18n.t('signin:description') }
            </p>
          </div> */}
          <div className='container card card-container' style={{background: 'transparent'}}>
            {/* 
            <img src='//ssl.gstatic.com/accounts/ui/avatar_2x.png' alt='profile-img' className='profile-img-card' /> 
            */}
            <ThemeProvider theme={theme}>
              <Formik 
                initialValues={initialValues} 
                onSubmit={this.handleSignin}
                validationSchema={this.validationSchema}
              >
                {(props) => {
                  const {
                    // errors,
                    // touched,
                    handleChange,
                    handleBlur
                  } = props;
                  return (
                    <Form>
                      <FormControl fullWidth>
                        <Typography variant='subtitle1'>
                          {i18n.t('signin:username')} <sup style={{ color: 'rgb(224, 0, 0, 1)' }}>*</sup>
                        </Typography>
                        <Field
                          variant='standard'
                          component={ TextField }
                          onChange={ handleChange }
                          onBlur={ handleBlur }
                          type='text'
                          id='username'
                          name='username'
                          placeholder='ID or Email Address' />
                        <ErrorMessage
                          name='username'
                          render={ msg => <span style={{ color: 'rgb(255, 0, 0)' }}>{msg}</span> } />
                      </FormControl>
                      <div className='divider-10' />
                      <FormControl fullWidth>
                        <Typography variant='subtitle1'>
                          {i18n.t('signin:password')} <sup style={{ color: 'rgb(224, 0, 0, 1)' }}>*</sup>
                        </Typography>
                        <Field
                          variant='standard'
                          component={ TextField }
                          onChange={ handleChange }
                          onBlur={ handleBlur }
                          type={ showPassword ? 'text':'password' }
                          id='password'
                          name='password'
                          placeholder='Password'
                          InputProps={{
                            endAdornment:(
                              <Button onClick={ this.handleShowPassword }>
                                { showPassword ? <Visibility />:<VisibilityOff /> }
                              </Button>
                            ),
                          }}
                        />
                        <ErrorMessage
                          name='password' 
                          render={ msg => <span style={{ color: 'rgb(255, 0, 0)' }}>{msg}</span> } />
                      </FormControl>
                      <div className='divider-20' />
                      <div><a href='/account/forgot-username' style={{ color: '#ffffffff' }}>{i18n.t('signin:findUsername')}</a></div>
                      <div className='divider-10' />
                      <div><a href='/account/forgot-password' style={{ color: '#ffffffff' }}>{i18n.t('signin:findPassword')}</a></div>
                      <div className='divider-20' />
                      <div className='row'>
                        <div className='col'>
                          <Button 
                            className='btn btn-custom btn-sm btn-block w-80'
                            onClick={this.handleSignup}>
                            <span>{i18n.t('signin:signup')}</span>
                          </Button>
                        </div>
                        <div className='col'>
                          <Button 
                            className='btn btn-custom btn-sm btn-block w-80'
                            type='submit'
                            disabled={loading}
                            style={{border: '1px solid rgb(0, 96, 0)'}}>
                            { loading && (<span className='spinner-border spinner-border-sm mr=3'></span>) }
                            <span>{i18n.t('signin:signin')}</span>
                          </Button>
                        </div>
                      </div>
                      { message && (
                        <>
                          <div className='divider-10' />
                          <div className='form-group'>
                            <div className='alert alert-danger' role='alert'>
                              <b>{ messageTitle }</b>
                              <br />
                              { message }
                              { messageLink && (
                                <Link to={messageLinkURL}>{messageLink}</Link>
                              )}
                            </div>
                          </div>
                        </>
                      ) }
                    </Form>
                  );
                }}
              </Formik>
            </ThemeProvider>
          </div>
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(Signin)
